// extracted by mini-css-extract-plugin
module.exports = {"main":"index_main__Y8PXH","list__item":"index_list__item__b359c"};